// Form is based on Formik
// Data validation is based on Yup
// Please, be familiar with article first:
// https://hackernoon.com/react-form-validation-with-formik-and-yup-8b76bda62e10
import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";

import { Input, Error } from "../../../../../../_metronic/_partials/controls";

// Validation schema
const SkillsUploadSchema = Yup.object().shape({
  file: Yup.mixed().nullable().required("Resume is required"),
});

export function SkillsUploadForm({ uploadSkills, actionsLoading, onHide }) {
  const { errorMsg } = useSelector(
    (state) => ({ errorMsg: state.skills.error }),
    shallowEqual
  );

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={{
          file: null,
        }}
        validationSchema={SkillsUploadSchema}
        onSubmit={(values) => {
          uploadSkills(values);
        }}
      >
        {({ handleSubmit }) => (
          <>
            <Modal.Body className="overlay overlay-block cursor-default">
              {actionsLoading && (
                <div className="overlay-layer bg-transparent">
                  <div className="spinner spinner-lg spinner-success" />
                </div>
              )}
              <Error message={errorMsg} />

              <Form className="form form-label-right">
                <div className="form-group row mb-0">
                  <div className="col-lg-8">
                    <label>Upload File</label>
                    <Field
                      name="file"
                      component={Input}
                      type="file"
                      placeholder="Upload file"
                      accept=".csv,.xlsx"
                    />
                  </div>
                </div>
                <div className="text-muted" style={{ fontSize: "0.9em" }}>
                  File should have job_role, skill_name, skill_variants, active
                  columns
                </div>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <button
                type="button"
                onClick={onHide}
                className="btn btn-light btn-elevate"
              >
                Cancel
              </button>

              <button
                type="submit"
                onClick={() => handleSubmit()}
                className="btn btn-primary btn-elevate"
              >
                Save
              </button>
            </Modal.Footer>
          </>
        )}
      </Formik>
    </>
  );
}
